/* /home/szymon/kreator2/frontend/src/components/editor/snapUtils.js v10.2.3 (dodano calculateCenteredX) */

// Importujemy parseGuideExpression, jeśli nie jest jeszcze zaimportowany
import { parseGuideExpression } from "./GuideUtils";

/////////////////////////////////////////////////////
// ORYGINALNE FUNKCJE – NIE USUWAMY NICZEGO
/////////////////////////////////////////////////////

/**
 * Funkcja snapToGuides – klasyczny mechanizm przyciągania do krawędzi/środka/itp.
 * Używana np. w handleObjectDragMove (EditorCanvasLogic).
 */
export function snapToGuides(
  unscaledX,
  unscaledY,
  width,
  height,
  scaleX,
  scaleY,
  guides,
  threshold = 5
) {
  console.log("[snapToGuides] start =>", {
    unscaledX,
    unscaledY,
    width,
    height,
    scaleX,
    scaleY,
    threshold
  });

  const actualW = width * (scaleX || 1);
  const actualH = height * (scaleY || 1);

  // Obliczamy różne krawędzie obiektu
  const leftX = unscaledX;
  const centerX = unscaledX + actualW / 2;
  const rightX = unscaledX + actualW;

  const topY = unscaledY;
  const centerY = unscaledY + actualH / 2;
  const bottomY = unscaledY + actualH;

  // Domyślne wyniki
  let bestX = unscaledX;
  let bestY = unscaledY;
  let bestDistX = threshold + 1;
  let bestDistY = threshold + 1;

  const nearGuides = [];

  // Iterujemy po tablicy guides (już powinny być { orientation, pos, snap } w px)
  guides.forEach((g, idx) => {
    console.log(`[snapToGuides] guide #${idx} =>`, g);
    if (g.orientation === "V") {
      const gx = g.pos;

      // Dist do left
      const distLeft = Math.abs(gx - leftX);
      if (distLeft <= threshold) {
        nearGuides.push({ orientation: "V", pos: gx });
        if (distLeft < bestDistX) {
          bestDistX = distLeft;
          bestX = unscaledX + (gx - leftX);
        }
      }

      // Dist do center
      const distCenter = Math.abs(gx - centerX);
      if (distCenter <= threshold) {
        nearGuides.push({ orientation: "V", pos: gx });
        if (distCenter < bestDistX) {
          bestDistX = distCenter;
          bestX = unscaledX + (gx - centerX);
        }
      }

      // Dist do right
      const distRight = Math.abs(gx - rightX);
      if (distRight <= threshold) {
        nearGuides.push({ orientation: "V", pos: gx });
        if (distRight < bestDistX) {
          bestDistX = distRight;
          bestX = unscaledX + (gx - rightX);
        }
      }
    } else if (g.orientation === "H") {
      const gy = g.pos;

      // Dist do top
      const distTop = Math.abs(gy - topY);
      if (distTop <= threshold) {
        nearGuides.push({ orientation: "H", pos: gy });
        if (distTop < bestDistY) {
          bestDistY = distTop;
          bestY = unscaledY + (gy - topY);
        }
      }

      // Dist do center
      const distMid = Math.abs(gy - centerY);
      if (distMid <= threshold) {
        nearGuides.push({ orientation: "H", pos: gy });
        if (distMid < bestDistY) {
          bestDistY = distMid;
          bestY = unscaledY + (gy - centerY);
        }
      }

      // Dist do bottom
      const distBottom = Math.abs(gy - bottomY);
      if (distBottom <= threshold) {
        nearGuides.push({ orientation: "H", pos: gy });
        if (distBottom < bestDistY) {
          bestDistY = distBottom;
          bestY = unscaledY + (gy - bottomY);
        }
      }
    }
  });

  // Jeżeli nie znaleziono nic bliżej niż threshold – wróć do oryginalnych X/Y
  if (bestDistX > threshold) {
    bestX = unscaledX;
  }
  if (bestDistY > threshold) {
    bestY = unscaledY;
  }

  // Unifikujemy nearGuides (żeby nie powielać identycznych)
  const uniqueGuides = [];
  const seen = new Set();
  nearGuides.forEach((gg) => {
    const key = `${gg.orientation}-${gg.pos}`;
    if (!seen.has(key)) {
      seen.add(key);
      uniqueGuides.push(gg);
    }
  });

  console.log("[snapToGuides] result =>", {
    bestX,
    bestY,
    activeGuides: uniqueGuides
  });

  return {
    x: bestX,
    y: bestY,
    activeGuides: uniqueGuides
  };
}

/**
 * Funkcja buildSnapGuides – tworzy listę prowadnic w px z definicji "guides".
 * Każdy guide w "guides" ma np. { orientation: "V", expression: "25%", ... }.
 */
export function buildSnapGuides(guides, baseWidth, baseHeight, parseFn) {
  if (!guides || guides.length === 0) {
   // console.log("[buildSnapGuides] brak guides => []");
    return [];
  }
  //console.log("[buildSnapGuides] wejsciowe guides =>", guides);

  return guides
    .map((gd, idx) => {
      // Przed parseFn – gd może mieć {id, expression, orientation}
      //console.log(`[buildSnapGuides] guide #${idx}`, gd);

      // Wywołujemy parseFn (parseGuideExpression) poprawnie:
      // przekazujemy expression i odpowiedni wymiar bazowy
      const orientation = gd.orientation; // Pobieramy orientację z oryginalnego obiektu guide
      const baseSize = orientation === "H" ? baseHeight : baseWidth;
      const pxPos = parseFn(gd.expression, baseSize); // parseFn zwraca już pozycję w px

      if (typeof pxPos !== "number" || isNaN(pxPos)) {
        //console.log(
        //  `[buildSnapGuides] => parseFn zwrócił nieprawidłową wartość (${pxPos}) dla expression "${gd.expression}" => pomijam`
        //);
        return null;
      }

      // Tworzymy bazowy obiekt prowadnicy (już z pozycją w px)
      const finalGuide = {
        orientation: orientation, // Używamy orientacji z oryginalnego obiektu
        pos: pxPos,
        snap: "center" // w oryginale stała "center"
      };

      //console.log(`[buildSnapGuides] => generating 3 snap types for pos=${pxPos}`);
      // Zamiast jednego obiektu, zwracamy tablicę trzech - dla start, center, end
      return [
        { ...finalGuide, snap: "start" },
        { ...finalGuide, snap: "center" },
        { ...finalGuide, snap: "end" }
      ];
    })
    .flat() // Spłaszczamy tablicę tablic [[g1s,g1c,g1e], [g2s,g2c,g2e]] do [g1s, g1c, g1e, g2s, g2c, g2e]
    .filter(Boolean);
}

// Usunięto funkcję autoSnapAllPagesWithSimulation


/**
 * Oblicza docelową pozycję X dla wyśrodkowanego obiektu tekstowego.
 * Używa zapisanej szerokości obiektu (textObj.width) zamiast dynamicznego pomiaru.
 * @param {object} textObj - Obiekt tekstowy z Konva (musi zawierać id, x, width, scaleX).
 * @param {array} pageGuides - Tablica definicji prowadnic dla danej strony (np. [{id, expression, orientation}]).
 * @param {number} baseWidth - Szerokość bazowa strony (pageWidth).
 * @param {number} baseHeight - Wysokość bazowa strony (pageHeight).
 * @returns {number|null} - Nowa pozycja X, jeśli wymaga zmiany, w przeciwnym razie null.
 */
export function calculateCenteredX(textObj, pageGuides, baseWidth, baseHeight) {
  // Sprawdzamy, czy mamy potrzebne dane
  if (!textObj || typeof textObj.width !== 'number' || typeof textObj.x !== 'number') {
    // console.warn(`[calculateCenteredX ${textObj?.id}] Brakujące dane obiektu (width, x).`);
    return null;
  }
  if (!pageGuides || !baseWidth || !baseHeight) {
    // console.warn(`[calculateCenteredX ${textObj?.id}] Brakujące dane strony (guides, baseWidth, baseHeight).`);
    return null;
  }

  // Budujemy prowadnice w px dla tej strony
  const snapGuides = buildSnapGuides(pageGuides, baseWidth, baseHeight, parseGuideExpression);

  // Filtrujemy, aby znaleźć WSZYSTKIE pionowe prowadnice centrujące
  const centerGuides = snapGuides.filter(g => g.orientation === 'V' && g.snap === 'center');

  if (centerGuides.length === 0) {
    // console.warn(`[calculateCenteredX ${textObj?.id}] Nie znaleziono żadnych pionowych prowadnic centrujących.`);
    return null;
  }

  const scaleX = textObj.scaleX || 1;
  // Używamy zapisanej szerokości obiektu!
  const objectWidth = textObj.width * scaleX;

  if (objectWidth <= 0) {
     // console.warn(`[calculateCenteredX ${textObj?.id}] Szerokość obiektu <= 0.`);
     return null;
  }

  // Obliczamy aktualny środek obiektu
  const objectCenterX = (textObj.x || 0) + objectWidth / 2;

  // Znajdujemy najbliższą prowadnicę centrującą
  let closestGuide = centerGuides[0];
  let minDistance = Math.abs(objectCenterX - closestGuide.pos);

  for (let i = 1; i < centerGuides.length; i++) {
    const distance = Math.abs(objectCenterX - centerGuides[i].pos);
    if (distance < minDistance) {
      minDistance = distance;
      closestGuide = centerGuides[i];
    }
  }

  // Obliczamy nową pozycję X na podstawie najbliższej prowadnicy
  const guidePosition = closestGuide.pos;
  const newX = guidePosition - (objectWidth / 2);

  // Porównujemy z obecną pozycją, zwracamy tylko jeśli zmiana jest znacząca
  if (Math.abs((textObj.x || 0) - newX) > 0.5) {
    // console.log(`[calculateCenteredX ${textObj.id}] Obliczono nową pozycję X: ${newX.toFixed(2)} (stara: ${textObj.x?.toFixed(2)}, szerokość: ${objectWidth.toFixed(2)})`);
    return newX;
  }

  // Pozycja jest już poprawna
  // console.log(`[calculateCenteredX ${textObj.id}] Pozycja X (${textObj.x?.toFixed(2)}) już poprawna.`);
  return null;
}
